export default {"src":"/_next/static/media/left-back-arrow.0bb6c1a6.svg","height":16,"width":35,"blurWidth":0,"blurHeight":0};